import QuizController from './QuizController'

export default QuizController